import { VertSpacerSm } from '@apps-common/components/layout'

interface IProps {
  Icon?: any
  IconComponent?: any
  subtitle: string
  title: string
  someOptionsDisabled?: boolean
  disabledMessage?: string
  children?: any
}

export const OptionsModalHeader: React.FC<IProps> = ({
  Icon,
  IconComponent,
  subtitle,
  title,
  someOptionsDisabled,
  disabledMessage,
  children
}) => {
  return (
    <>
      <div className='flex flex-col items-center'>
        {Icon && (
          <div className='w-[50px] h-[50px] rounded-full bg-surface text-text-muted border border-border flex items-center justify-center'>
            <Icon className='text-[1.2em]' />
          </div>
        )}
        {IconComponent && IconComponent}
        <VertSpacerSm />
        <p className='jost-medium text-text-muted/70 text-[0.7em]'>{subtitle}</p>
        <p className='jost-light text-text max-w-[200px] text-nowrap overflow-hidden text-ellipsis'>{title}</p>
        {someOptionsDisabled && (
          <p className='text-text-muted/70 text-[0.75em] text-center'>{disabledMessage || 'Some actions currently disabled'}</p>
        )}
        <VertSpacerSm />
        {children && <>{children}</>}
      </div>
      <div className='border-t border-border w-full mx-auto mt-[10px] mb-[20px]' />
    </>
  )
}
